export const DEFAULT_LABELS_COLOR = {
  accent: {
    light: "#D3E4FC",
    dark: "#b48484",
  },
  text: {
    light: "#0853BA",
    dark: "#000000",
  },
};

export const DEFAULT_SPACES_COLOR = {
  accent: {
    light: "#015DDB",
    dark: "#b48484",
  },
  text: {
    light: "#ffffff",
    dark: "#000000",
  },
};

export const DEFAULT_BORDER_RADIUS = 3;